<template>
  <BaseNoticeItem>
    <template #head>
      <strong>
        {{ $t('Background Checks In Progress') }}
      </strong>
    </template>
    <template #body>
      <div>
        {{
          $t(
            "Background checks have been initiated. The contract will be available for signature once all checks are complete. The worker's start date may be adjusted based on the completion of the background checks.",
          )
        }}
      </div>
    </template>
  </BaseNoticeItem>
</template>

<script setup lang="ts">
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { $t } from '@/composables/translation'
</script>
